module.exports = __webpack_public_path__ + "static/img/bg_1.d15b14d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/bg_1.jpg
// module id = pMbZ
// module chunks = 1